.root {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
.root legend {
  margin-bottom: var(--space-2);
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
}
.options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-2);
}
.option {
  display: flex;
  align-items: center;
  min-width: 0;
  min-height: var(--control-height);
  gap: var(--space-2);
  padding: var(--space-2);
  border-radius: var(--radius-lg);
  background: var(--color-surface-subtle);
  border: 1px solid var(--color-surface-tinted);
  box-shadow: var(--shadow-control);
}
.option[data-checked] {
  border-color: var(--color-brand);
  background: color-mix(in srgb, var(--color-brand) 10%, var(--color-surface-raised));
}
.option img {
  width: var(--space-8);
  height: var(--space-8);
  object-fit: contain;
  flex: none;
}
.option > span {
  flex: 1;
  font-size: var(--mantine-font-size-xs);
  font-weight: 700;
}
@media (max-width: 22em) {
  .options {
    grid-template-columns: minmax(0, 1fr);
  }
}
